import React, { useState, useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Page from '../../../common/Page';
import SubHeader from '../../../common/SubHeader';
import MenuCard from '../../../common/MenuCard';
import Loader from '../../../common/Loader';
import EmptyState from '../../../common/EmptyState';
import { listWithdrawalEvents } from '../../../common/api';
import { formatEventDateTime } from '../../../common/dates';
import { displayEventName } from '../../../common/events';
import { useCurrentUser, isSuperAdmin } from '../../../common/UserContext';

// Eventi pubblici passati per cui la notifica di ritiro non è ancora stata inviata (solo super-admin)
function WithdrawalEvents() {
  const navigate = useNavigate();
  const user = useCurrentUser();
  const allowed = isSuperAdmin(user);
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!allowed) return;
    listWithdrawalEvents()
      .then((result) => setEvents(result.events || []))
      .catch((err) => {
        console.error('Error fetching events:', err);
        setError('Errore nel caricamento degli eventi');
        toast.error('Errore nel caricamento degli eventi');
      })
      .finally(() => setIsLoading(false));
  }, [allowed]);

  if (!allowed) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  if (isLoading) {
    return <Loader />;
  }

  return (
    <Page>
      <SubHeader title="Notifica Ritiro" onBack={() => navigate('/admin/dashboard')} />
      {error && <EmptyState text={error} />}
      {!error && events.length === 0 && <EmptyState text="Nessun evento da notificare" />}
      {events.map((event) => (
        <MenuCard
          key={event.eventKey}
          title={displayEventName(event.eventName)}
          subtitle={formatEventDateTime(event.when)}
          onClick={() => navigate(`/admin/withdrawal/event?eventKey=${encodeURIComponent(event.eventKey)}`)}
        />
      ))}
    </Page>
  );
}

export default WithdrawalEvents;
